/**
 * Auto-generated from @intelishs-group/schema-core v5.1.0
 * Source: filemanagerTypes — File Manager API
 * Generated: 2026-10-09
 * Do not edit manually. Run: npm run generate:services
 */
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiBaseService } from './api-base.service';
import type {
  BooleanResponseDto,
  FileCatologDTOICollectionResponseDto,
  ProblemDetails,
  SaveFileResponseResponseDto,
  StringResponseDto,
} from '@schemas/filemanager';

@Injectable({ providedIn: 'root' })
export class FileManagerService extends ApiBaseService {
  private baseUrl = `${environment.BaseUrl}/FileManager/`;

  /** Agrega un nuevo archivo al sistema de almacenamiento. */
  async agregateFiles(body: FormData) {
    return lastValueFrom(
      this.http.post<SaveFileResponseResponseDto>(`${this.baseUrl}AgregateFiles`, body),
    );
  }

  /** Elimina un archivo del sistema por su identificador. */
  async deleteFiles(idFile: number) {
    return this.delete<BooleanResponseDto>(`${this.baseUrl}DeleteFiles`, {
      idFile: idFile.toString(),
    });
  }

  /** Actualiza un archivo existente en el sistema. */
  async updateFile(body: FormData) {
    return lastValueFrom(
      this.http.put<SaveFileResponseResponseDto>(`${this.baseUrl}UpdateFile`, body),
    );
  }

  /** Descarga un archivo por su identificador. */
  async downodalFile(idFile: number) {
    return this.safeRequest<ProblemDetails>(
      this.http.get(`${this.baseUrl}DownodalFile`, {
        params: {
        idFile: idFile.toString(),
        },
      }),
    );
  }

  /** Obtiene el catálogo de tipos de archivos disponibles. */
  async getFileCatalog() {
    return this.get<FileCatologDTOICollectionResponseDto>(`${this.baseUrl}GetFileCatalog`);
  }

  /** Verifica el estado de salud del API. */
  async health() {
    return this.get<StringResponseDto>(`${this.baseUrl}health`);
  }
}
